import {map, redirect} from 'navi';
import {UserRole} from 'providers/user';
import {hasRole} from 'providers/user/user-utils';

/**
 * Checks if a user is authenticated to access a particular route by comparing
 * the assigned roles of the user to the allowed roles of the route.
 * @param allowedRoles The roles allowed to access this route.
 * @param matcher The child matcher
 */
export const withAuthentication = (allowedRoles: UserRole[], matcher: any) => map((request, context: any) => {
  const { user } = context;

  if (user && user.roles.length) {
    const authenticated = hasRole(allowedRoles, user.roles);
    if (authenticated) {
      return matcher;
    }
  }
  return redirect('/401');
});
